import { Constructor } from './constructor';
import { AnyKeyAnyType } from '../../../shared-third-party/common.type';

export interface ClassList {
  label: string;
  wrapClassList: string;
  labelClassList: string;
  inputClassList: string;
  getWrapClassList: () => { [key: string]: boolean };
  getInputClassList: () => { [key: string]: boolean };
  getLabelClassList: () => { [key: string]: boolean };
}

export type ClassListCtor = Constructor<ClassList>;

/**
 * Миксина для установки классов в компоненты
 */
export function mixinClassList<T extends Constructor<any>>(base: T): ClassListCtor & T {
  return class extends base {
    label = '';
    wrap = true;

    /**
     * Устанавливает список классов для инпута
     */
    set inputClassList(value: string) {
      if (value && value.length) {
        this._inputClassList = value.split(' ').reduce(
          (classList, className) => {
            classList[className.trim()] = true;

            return classList;
          },
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          {} as { [key: string]: boolean },
        );
      } else {
        this._inputClassList = {};
      }
    }
    private _inputClassList: { [key: string]: boolean } = {};

    /**
     * Устанавливает список классов для наименования
     */
    set labelClassList(value: string) {
      if (value && value.length) {
        this._labelClassList = value.split(' ').reduce(
          (classList, className) => {
            classList[className.trim()] = true;

            return classList;
          },
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          {} as { [key: string]: boolean },
        );
      } else {
        this._labelClassList = {};
      }
    }
    private _labelClassList: { [key: string]: boolean } = {};

    /**
     * Устанавливает список классов для главного блока в компоненте
     */
    set wrapClassList(value: string) {
      if (value && value.length) {
        this._wrapClassList = value.split(' ').reduce(
          (classList, className) => {
            classList[className.trim()] = true;

            return classList;
          },
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          {} as { [key: string]: boolean },
        );
      } else {
        this._wrapClassList = {};
      }
    }
    private _wrapClassList: { [key: string]: boolean } = {};

    /**
     * Конструктор
     */
    constructor(...args: any[]) {
      super(...args);
    }

    /**
     * Получить список классов инпута
     */
    getInputClassList(): AnyKeyAnyType {
      return {
        ...this._defaultInputClassList(),
        ...this._inputClassList,
      };
    }

    /**
     * Получить список классов наименования
     */
    getLabelClassList(): AnyKeyAnyType {
      return {
        ...this._defaultLabelClassList(),
        ...this._labelClassList,
      };
    }

    /**
     * Получить список классов главного блока в компоненте
     */
    getWrapClassList(): AnyKeyAnyType {
      return {
        ...this._defaultWrapClassList(),
        ...this._wrapClassList,
      };
    }

    /**
     * Получить список классов инпута по умолчанию
     */
    private _defaultInputClassList(): { [key: string]: boolean } {
      return {
        'col-12 pr-0': true,
        'col-md-6': !!this.label,
        'pl-0': !this.label,
        'form-control-static': true,
      };
    }

    /**
     * Получить список классов наименования по умолчанию
     */
    private _defaultLabelClassList(): { [key: string]: boolean } {
      return {
        'col-12': true,
        'col-md-6': true,
        'pl-0': true,
      };
    }

    /**
     * Получить список классов главного блока в компоненте по умолчанию
     */
    private _defaultWrapClassList(): { [key: string]: boolean } {
      return {
        row: this.wrap,
        'form-group': true,
        'mx-0': true,
      };
    }
  };
}
